import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query FacultyMembers($page: Int, $perPage: Int, $search: String, $active: Boolean) {
    FacultyMembers(page: $page, perPage: $perPage, search: $search, active: $active) {
      items {
        id
        name
        active
        title
        isCoordinator
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  name: string;
  title: string;
  active: boolean;
  isCoordinator: boolean;
}

export interface GetAllGql {
  FacultyMembers: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
